import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-416313ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Search Show: ", -1))
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Search", -1))
const _hoisted_4 = {
  key: 0,
  class: "card-wrapper"
}

import { inject, Ref, ref } from 'vue';
import { TVMazeResponse } from '@/models/models';
import ShowCard from '@/views/ShowCard.vue';
import Loading from '@/views/Loading.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const searchInput = ref('');
const shows = inject<Ref<TVMazeResponse[]>>('shows', ref([]));
const loading = ref(false);

const search = async () => {
  loading.value = true;
  const response = await fetch(`https://api.tvmaze.com/search/shows?q=${searchInput.value}`);
  shows.value = await response.json();
  loading.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _withModifiers(search, ["prevent"])
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "search",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event))
      }, null, 512), [
        [_vModelText, searchInput.value]
      ]),
      _hoisted_3
    ], 40, _hoisted_2),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shows), (show) => {
            return (_openBlock(), _createBlock(ShowCard, {
              key: show.show.id,
              show: show.show,
              class: "card"
            }, null, 8, ["show"]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(Loading, { key: 1 }))
  ], 64))
}
}

})